import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { IGatsbyImageData } from "gatsby-plugin-image";
import styled from "styled-components";

import { A, P } from "@util/standard";
import { Image } from "@components/global";
import { colors } from "@util/constants";
import { Color } from "@util/types";

interface Props {
  linktext?: string | undefined | null;
  url?: string | undefined | null;
  internallink?: boolean | undefined | null;
  newwindow?: boolean | undefined | null;
  asset?: IGatsbyImageData | undefined | null;
  className?: string;
  color?: Color;
  isUnderlined?: boolean;
  isBold?: boolean;
  hoverColor?: Color;
  padding?: string;
  opacity?: number;
  download?: boolean;
  underlineOnHover?: boolean;
}

const StyledGatsbyLink = styled(GatsbyLink)<{
  padding?: string;
  underlined?: number;
  opacity?: number;
}>`
  ${({ opacity }) => opacity && `opacity: ${opacity};`}
  user-select: none;
  ${({ padding }) => padding && `padding: ${padding}`};
  text-decoration: ${props => (props.underlined === 1 ? `underline` : `none`)};
`;

const ImageWrapper = styled.div`
  &:hover {
    opacity: 0.6;
  }
`;

const StyledP = styled(P)<{
  color?: Color;
  underlineOnHover?: boolean;
  hoverColor?: Color;
}>`
  ${({ color }) => color && `color:${colors[color]}`};
  ${({ hoverColor }) =>
    hoverColor &&
    `&:hover {
      color: ${colors[hoverColor]};


    }`}

  &:hover {
    ${({ underlineOnHover }) => underlineOnHover && `text-decoration-line:underline`};
  }

  margin: 0;
  &:hover {
    font-weight: 600;
  }
`;

const Link = ({
  linktext,
  url,
  internallink,
  newwindow,
  asset,
  className = "",
  color,
  hoverColor,
  isUnderlined,
  isBold,
  padding,
  opacity,
  download,
  underlineOnHover,
}: Props) => {
  if (internallink) {
    const to = url === "/" ? "/" : `${url}`;

    return (
      <StyledGatsbyLink
        activeClassName="active"
        className={className}
        to={to}
        padding={padding}
        underlined={isUnderlined ? 1 : 0}
        opacity={opacity}
      >
        {asset ? (
          <ImageWrapper>
            <Image image={asset} />
          </ImageWrapper>
        ) : (
          <StyledP
            hoverColor={hoverColor}
            color={color}
            underlined={isUnderlined}
            fontWeight={isBold ? "bold" : "normal"}
            underlineOnHover={underlineOnHover}
          >
            {linktext}
          </StyledP>
        )}
      </StyledGatsbyLink>
    );
  }

  return (
    <A
      href={url ?? "/"}
      className={className}
      target={newwindow ? "_blank" : ""}
      rel={newwindow ? "noreferrer" : ""}
      color={color}
      opacity={opacity}
      underlined={isUnderlined}
      download={download}
    >
      {asset ? (
        <ImageWrapper>
          <Image image={asset} />
        </ImageWrapper>
      ) : (
        <StyledP>{linktext}</StyledP>
      )}
    </A>
  );
};

export default Link;
